import React, { useEffect, useState } from "react";
import Meal from "./Meal/Meal";

const Main = ({ search }) => {
  // States
  const [meals, setMeals] = useState([]);

  // Side Effects
  useEffect(() => {
    fetch(`https://www.themealdb.com/api/json/v1/1/search.php?s=${search}`)
      .then((res) => res.json())
      .then((data) => setMeals(data.meals));
  }, [search]);
  return (
    <div className="container mx-auto mt-10 bg">
      <h2 className=" text-2xl">Found Results: {meals?.length} Items</h2>
      {/* Foods Container/ can be a Component */}
      <div className="grid grid-cols-1 px-10 md:grid-cols-2 md:px-0 lg:grid-cols-3 gap-5 py-5">
        {meals?.map((meal) => (
          <Meal key={meal.idMeal} meal={meal}></Meal>
        ))}
      </div>
    </div>
  );
};

export default Main;
